// extracted by mini-css-extract-plugin
export var childrenContainer = "_40-0";